import {
    MediaProcessingService,
    type MediaSoundProcessorOptions,
    type NoiseCancellationType,
} from '@yandex-360/telemost-sdk/device-manager';

import { getNoiseCancellationValueByType, getSoundProcessingOptions } from '../../../goloom-sdk/helpers';
import { mapSoundProcessorOptionsFromGoloom } from './goloom-type-mappers';

export class GoloomMediaProcessing extends MediaProcessingService {
    buildSoundProcessorOptions(noiseCancellationType: NoiseCancellationType): MediaSoundProcessorOptions {
        const noiseCancellation = getNoiseCancellationValueByType(noiseCancellationType);

        return mapSoundProcessorOptionsFromGoloom({
            ...getSoundProcessingOptions(),
            noiseCancellation,
        });
    }
}
